import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, tap, throwError, catchError, of } from 'rxjs';
import { AuthenticateRequest } from '../_models/Authentication/authenticate-request';
import { SocialAuthenticateRequestModel } from '../_models/Authentication/social-authenticate-request';
import { environment } from 'src/environments/environment';
import { RegistrationRequest } from '../_models/Authentication/registration-request';
import { VenueModelRequest } from '../_models/Venue/VenueModel';
import { VenueService } from './venue.service';
import { CompanyService } from '../company.service';
import { EventModelRequest, UpdateEventModelRequest } from '../_models/Event/EventModel';
import { EventService } from './event.service';
import { ReservationService } from './reservation.service';
import { ApproveReservationRequest, RefuseReservationRequest, ReservationDetailRequest } from '../_models/Reservation/ReservationModel';
import { ErrorCodeMessageType, getErrorCodeMessageType } from '../_models/Statuses/Statuses';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UserModelRequest } from '../_models/User/UserModel';
import { DeactivateHostModelRequest, GetHostsModelResponse, HostModelRequest } from '../_models/Host/HostModel';
import { HostService } from './host.service';
import { PushNotificationRequestModel } from '../_models/PushNotification/PushNotificationModel';

import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { AnalyticsConstants } from '../global-constants/analytics';
import { ForgotPasswordRequest } from '../_models/Authentication/forgot-password-request';
import { ConfirmPasswordRequest } from '../_models/Authentication/confirm-password-request';
import { RefreshTTokenRequest } from '../_models/Authentication/refresh-token-request';
import { CompanyModel, CompanyRequest } from '../_models/Company/CompanyModel';
import { SocialRegisterRequestModel } from '../_models/Authentication/social-register-request';
import { StripePaymentModel } from '../_models/Payment/stripe-payment.model';
import { PagingModel } from '../_models/Common/paging-model';
import { StripeCheckoutModel } from '../_models/Payment/stripe-checkout.model';
import { VerifyEmailRequest } from '../_models/Authentication/verify-email-request';
import { HalkbankPaymentModel } from '../_models/Payment/halkbank.model';
import { HttpService } from '../chat/services/common/http-service';
import { SearchVenuesModel } from "../_models/Venue/SearchVenuesModel";
import { SearchEventModel } from "../_models/Event/SearchEventModel";
import { Operations } from "../_models/Reservation/ReservationStatus";
import {VenueMaxCapacityModel} from "../_models/Venue/VenueMaxCapacityModel";
import { TotalReservationsForVenueRequestDTO } from "../_models/Report/TotalReservationsForVenueModelDTO";
import { MostVisitedEventsRequestDTO} from "../_models/Report/MostVisitedEventsModelDTO";
import {UpcomingEventReservationsModelDTO} from "../_models/Report/UpcomingEventReservationsModelDTO";
import {ReservationsDetailsForEventModelDTO} from "../_models/Report/ReservationsDetailsForEventModelDTO";
import {WeeklyReservationsModelDTO, WeeklyReservationsRequestDTO} from "../_models/Report/WeeklyReservationsModelDTO";
import {PastOrUpcomingEventReservationsRequestDTO} from "../_models/Report/PastOrUpcomingEventReservationsRequestDTO";

const BUSSN_API = environment.apiURL + '/api/business/User/';
const AUTH_API = environment.apiURL + '/api/adv/User/';
const COMPANY_API = environment.apiURL + '/api/adv/Company/';
const VENUE_API = environment.apiURL + '/api/adv/Venue/';
const VENUE_API_BUSINESS = environment.apiURL + '/api/business/Venue/';
const EVENT_API = environment.apiURL + '/api/adv/Event/';
const RESERVATION_API = environment.apiURL + '/api/adv/Reservation/';
const REPORT_API = environment.apiURL + '/api/adv/Report/';

const HOST_API = environment.apiURL + '/api/hst/Host/';

const PAYMENT_API = environment.apiURL + '/api/adv/Payment/'

const Test_PAYMENT_API = environment.apiURL + '/api/adm/Payment/'

const ADM_API = environment.apiURL + '/api/adm/User/';
const ADM_PRODUCT_API = environment.apiURL + '/api/adm/Product/';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const httpOptionsHalk = {
  headers: new HttpHeaders({ 'Content-Type': 'text/html;charset=UTF-8' })
}
// const params = new HttpParams();

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient,
    private venueService: VenueService,
    private companyService: CompanyService,
    private eventService: EventService,
    private reservationService: ReservationService,
    private hostService: HostService,
    private snackBar: MatSnackBar,
    private router: Router,
    private analytics: AngularFireAnalytics,
    private _httpService: HttpService, private _httpClient: HttpClient
  ) { }

  handleError(error: HttpErrorResponse) {
    if (error.status == 422) {
        this.snackBar.open('The email has already been taken!', 'Cancel', {
          duration: 3000
        });
      return throwError(() => new Error('Server Error!'));
    }
    else if (error.error.StatusCode !== 200 || error.error.StatusCode !== 0) {
      let message = this.getErrorMessage(
        getErrorCodeMessageType(error.error.StatusCode)
      )
      this.snackBar.open(message, 'Cancel', {
        duration: 3000
      });

      return throwError(() => new Error(message));
    }
    else if (error.status == 500) {
      this.snackBar.open('Server Error!', 'Cancel', {
        duration: 3000
      });
      return throwError(() => new Error('Server Error!'));
    } else {
      this.snackBar.open('An uknown error ocurred!', 'Cancel', {
        duration: 3000
      });
      return throwError(() => new Error('An uknown error ocurred!'));
    }
  }

  getErrorMessage(
    type: ErrorCodeMessageType,
  ) {
    let message = ''

    switch (type) {
      case ErrorCodeMessageType.ERROR_USERALREADYEXIST:
        message = 'Email address is already being used in a different account!'
        break
      case ErrorCodeMessageType.ERROR_USERNOTFOUND:
        message = 'Wrong credentials!'
        break
      case ErrorCodeMessageType.ERROR_INVALIDTOKEN:
        message = 'The token is expired and needs to be re-authenticated!'
        break
      case ErrorCodeMessageType.ERROR_OBJECTALREADYEXISTS:
        message = 'There is already an object of this type with the same ID in the database!'
        break
      case ErrorCodeMessageType.ERROR_ADDRESSISNOTCONFIRMED:
        message = 'The address could not be verified!'
        break
      case ErrorCodeMessageType.ERROR_INVALIDPARAMETERS:
        message = 'Unexpected error has occurred - Invalid Parameters!'
        break
      case ErrorCodeMessageType.ERROR_USERNOTAUTHORIZED:
        message = 'You are not authorized!'
        break
      case ErrorCodeMessageType.ERROR_USEREMAILNOTVERFIED:
        message = 'Your email is not verified!'
        break
      case ErrorCodeMessageType.ERROR_UNAUTHORIZED:
        message = 'You are not authorized to perform this action!'
        break
      case ErrorCodeMessageType.ERROR_VALIDATION:
        message = 'Unexpected error has occurred - one or more parameters are not valid!'
        break
      case ErrorCodeMessageType.SERVER_ERROR:
        message = 'Server Error!'
        break
    }

    return message
  }

  //---USER----
  /** POST: authenticate user with credentials */
  authenticate(authCredentials: AuthenticateRequest): Observable<any> {
    // this.analytics.logEvent(AnalyticsConstants.loginEvent);
    return this.http
      .post<AuthenticateRequest>(AUTH_API + 'authenticate', authCredentials, httpOptions)
      .pipe(
        tap((response: any) => { }),
        catchError(this.handleError.bind(this))
      )
  }

  authenticateSocialLogin(socialAuthCredentials: SocialAuthenticateRequestModel) {
    return this.http.
    post<SocialAuthenticateRequestModel>(BUSSN_API + 'authenticatesociallogin', socialAuthCredentials, httpOptions)
    .pipe(
      tap((response: any) => {}),
        catchError(this.handleError.bind(this))
    )
  }

  register(registerCredentials: RegistrationRequest): Observable<RegistrationRequest> {
    // this.analytics.logEvent(AnalyticsConstants.registerEvent);
    return this.http
      .post<RegistrationRequest>(AUTH_API + 'register', registerCredentials, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  registerSociaLogin(socailRegisterCredentials: SocialRegisterRequestModel){
    return this.http.
    post<SocialRegisterRequestModel>(AUTH_API + 'registersociallogin', socailRegisterCredentials, httpOptions)
    .pipe(
      tap((response: any) => {}),
        catchError(this.handleError.bind(this))
    )
  }

  refreshToken(token: RefreshTTokenRequest): Observable<any> {
    return this.http
      .post<RefreshTTokenRequest>(BUSSN_API + 'refresh-token', token, httpOptions)
      .pipe(
        tap((response: any) => { }),
        catchError(this.handleError.bind(this))
      )
  }

  forgotpassword(forgotPasswordRequest: ForgotPasswordRequest): Observable<any> {
    return this.http
      .post<ForgotPasswordRequest>(BUSSN_API + 'forgotpassword', forgotPasswordRequest, httpOptions)
      .pipe(
        tap((response: any) => { }),
        catchError(this.handleError.bind(this))
      )
  }

  verifyemail(verifyEmailRequest: VerifyEmailRequest){
    return this.http
      .post<VerifyEmailRequest>(BUSSN_API + 'verifyemail', verifyEmailRequest, httpOptions)
      .pipe(
        tap((response: any) => {}),
        catchError(this.handleError.bind(this))
      )
  }

  confirmpassword(confirmPasswordRequest: ConfirmPasswordRequest): Observable<any> {
    return this.http
      .post<ConfirmPasswordRequest>(BUSSN_API + 'confirmpassword', confirmPasswordRequest, httpOptions)
      .pipe(
        tap((response: any) => { }),
        catchError(this.handleError.bind(this))
      )
  }

  signOut(isRemembered: any): Observable<any> {
    return this.http
      .post<any>(BUSSN_API + `signout?isRemembered=${isRemembered}`, httpOptions)
      .pipe(
        tap(response => { }),
        catchError(this.handleError.bind(this))
      )
  }

  //------ FCM Token to Backed -------/
  /** Registers new fcm token for the authorized user */
  registerfcmtoken(userId: string, FCMtoken: string): Observable<any> {
    let req: PushNotificationRequestModel = new PushNotificationRequestModel();
    req.deviceID = userId;
    req.deviceFCMToken = FCMtoken;
    return this.http.post<any>(AUTH_API + 'registerfcmtoken', req, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  getUserProfile(): Observable<any> {
    // this.analytics.logEvent(AnalyticsConstants.getUserProfileEvent);
    return this.http
      .get(AUTH_API + 'getuserprofile', httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  updateUserProfile(userProfile: UserModelRequest): Observable<any> {
    let formData = new FormData();
    formData.append('FirstName', userProfile.FirstName as string)
    formData.append('LastName', userProfile.LastName as string)
    formData.append('Phone', userProfile.Phone as string)
    formData.append('DateOfBirth', userProfile.DateOfBirth as string)
    // this.analytics.logEvent(AnalyticsConstants.updateProfileEvent);
    return this.http
      .post<any>(AUTH_API + 'updateuserprofile', formData)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  uploadProfilePicture(image: any): Observable<any> {
    let formData = new FormData();
    formData.append('File', image as string)
    // this.analytics.logEvent(AnalyticsConstants.uploadProfilePictureEvent);
    return this.http
      .post<any>(BUSSN_API + 'uploadprofilepicture', formData)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  //PRODUCT --country ids-- advertiser
  getallcountrynames():Observable<any> {
    return this.http
      .get(ADM_PRODUCT_API + 'getallcountrynames', httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  //---COMPANY----
  getCompanyDetails(): Observable<any> {
    // let queryParams = new HttpParams();
    // queryParams = queryParams.append("companyId", companyId);
    // this.analytics.logEvent(AnalyticsConstants.getCompanyDetailsEvent);
    return this.http.get(COMPANY_API + 'getcompanydetails', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      // params: queryParams
    })
      .pipe(
        catchError(this.handleError.bind(this)),
        tap(company => {
          //@ts-ignore
          this.companyService.setCompany(company)
        })
      )
  }

  updateCompany(company: CompanyRequest): Observable<any> {
    // this.analytics.logEvent(AnalyticsConstants.updateCompanyDetailsEvent);
    return this.http
      .post<CompanyRequest>(COMPANY_API + 'updatecompany', company, httpOptions)
      .pipe(
        tap((response: any) => {
        }),
        catchError(this.handleError.bind(this))
      )
  }

  getallmembershipplansforcompany(pageNumber: number): Observable<any>{
    let queryParams = new HttpParams();
    queryParams = queryParams.appendAll({
      pageNumber: pageNumber,
      pageSize: 10
    });
    return this.http.get(COMPANY_API + 'getallmembershipplansforcompany', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    })
    .pipe(
      catchError(this.handleError.bind(this))
    )
  }

  //---VENUE----
  getVenues(searchModel?: SearchVenuesModel): Observable<any> {
    searchModel = searchModel ? searchModel : new SearchVenuesModel();
    let queryParams = new HttpParams();
    queryParams = queryParams.appendAll({
      PageNumber: searchModel.pageNumber,
      PageSize: searchModel.pageSize,
      Filter: searchModel.name
    });
    // this.analytics.logEvent(AnalyticsConstants.getVenuesEvent);
    return this.http.get(VENUE_API + 'listvenues', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    })
      .pipe(
        catchError(this.handleError.bind(this)),
        tap(venues => {
          //@ts-ignore
          this.venueService.setVenues(venues.data, venues.pageNumber , venues.totalPages);
        })
      );
  }



  getVenue(venueID: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("venueId", venueID);
    // this.analytics.logEvent(AnalyticsConstants.getVenueDetailsEvent);
    return this.http.get(VENUE_API + 'getvenuedetails', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    });
  }



  listVenuesForCombo(): Observable<any> {
    return this.http.get(VENUE_API + 'listvenuesforcombo', httpOptions)
    .pipe(
      catchError(this.handleError.bind(this)),
      tap(venues => {})
    )
    ;
  }
  updateMaximumCapacity(venueId: string, maxCapacity: number): Observable<any> {
    let capacityModel = new VenueMaxCapacityModel();
    capacityModel.venueId = venueId;
    capacityModel.maxCapacity = maxCapacity;
    return this.http
      .post<any>(VENUE_API_BUSINESS + 'updatemaxcapacityforvenue', capacityModel)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  //---EVENT----
  getEvents(searchModel?: SearchEventModel): Observable<any> {
    searchModel = searchModel ? searchModel : new SearchEventModel();
    let queryParams = new HttpParams();
    queryParams = queryParams.appendAll({
      PageNumber: searchModel.pageNumber,
      PageSize: searchModel.pageSize,
      Status: searchModel.status,
      Filter: searchModel.name
    });
    // this.analytics.logEvent(AnalyticsConstants.getEventsEvent);
    return this.http.get(EVENT_API + 'listevents', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    }).pipe(
      catchError(this.handleError.bind(this)),
      tap((events: any) => {
        this.eventService.setEvents(events.data, events.pageNumber, events.totalPages, events.totalRecords);
      })
    )
  }

  getEventDetails(eventId: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("eventId", eventId);
    // this.analytics.logEvent(AnalyticsConstants.getEventDetailsEvent);
    return this.http.get(EVENT_API + 'geteventdetails', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    })
      .pipe(
        catchError(err => {
          this.router.navigateByUrl("page-not-found");
          return of(null);
        })
      )
  }

  publishEvent(eventId: string | undefined): Observable<any> {
    // this.analytics.logEvent(AnalyticsConstants.publishEventEvent);
    return this.http
      .post<any>(EVENT_API + `publishevent?eventId=${eventId}`, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  cancelEvent(eventId: string | undefined): Observable<any> {
    // this.analytics.logEvent(AnalyticsConstants.cancelEventEvent);
    return this.http
      .post<any>(EVENT_API + `cancelevent?eventId=${eventId}`, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  addEvent(event: EventModelRequest): Observable<EventModelRequest> {
    let formData = this.eventService.setEventValues(event);
    // this.analytics.logEvent(AnalyticsConstants.addEventEvent);
    return this.http.post<EventModelRequest>(EVENT_API + 'addevent', formData);
  }

  deleteEvent(eventId: string | undefined): Observable<any> {
    // this.analytics.logEvent(AnalyticsConstants.deleteEventEvent);
    return this.http
      .post<any>(EVENT_API + `deleteevent?eventId=${eventId}`, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  updateEvent(event: UpdateEventModelRequest): Observable<UpdateEventModelRequest> {
    // this.analytics.logEvent(AnalyticsConstants.updateEventEvent);
    let formData = this.eventService.setUpdateValues(event);
    return this.http.post<UpdateEventModelRequest>(EVENT_API + 'updateevent', formData);
  }

  //---RESERVATION----
  getReservations(eventId: string, status?: Operations, concat?: boolean): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("eventId", eventId);
    if (status) {
      queryParams = queryParams.append("Status", status);
    }
    // this.analytics.logEvent(AnalyticsConstants.getReservationsEvent);
    return this.http.get(RESERVATION_API + 'listreservations', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    }).pipe(
      catchError(this.handleError.bind(this)),
      tap(reservations => {
        // @ts-ignore
        this.reservationService.setReservations(reservations, eventId, status, concat);
      })
    )
  }

  getReservationDetails(reservationId: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("reservationId", reservationId);
    // this.analytics.logEvent(AnalyticsConstants.getReservationDetailsEvent);
    return this.http.get(RESERVATION_API + 'viewreservation', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    }).pipe(
      catchError(this.handleError.bind(this))
    )
  }

  confirmReservation(reservationId: string | undefined): Observable<any> {
    let req: ApproveReservationRequest = new ApproveReservationRequest();
    req.reservationId = reservationId;
    req.note = "Your reservation is approved by General Admin";
    req.subscriberEmail = "subscriber@example.com";
    req.subscriberName = "Jonathan Johnson";
    // return this.http.post<any>(RESERVATION_API + `approvereservation?reservationId=${reservationId}`, httpOptions);
    // this.analytics.logEvent(AnalyticsConstants.confirmReservationEvent);
    return this.http.post<any>(RESERVATION_API + 'approvereservation', req, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  refuseReservation(reservationId: string | undefined): Observable<any> {
    let req: RefuseReservationRequest = new RefuseReservationRequest();
    req.reservationId = reservationId;
    req.note = "Your reservation is refused by General Admin";
    req.subscriberEmail = "subscriber@example.com";
    req.subscriberName = "Jonathan Johnson";
    // this.analytics.logEvent(AnalyticsConstants.refuseReservationEvent);
    return this.http.post<any>(RESERVATION_API + 'refusereservation', req, httpOptions).
      pipe(
        catchError(this.handleError.bind(this))
      );
  }

  // HOST
  createHost(host: HostModelRequest): Observable<HostModelRequest> {
    // this.analytics.logEvent(AnalyticsConstants.createHostEvent);
    return this.http
      .post<HostModelRequest>(HOST_API + 'createhost', host, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  getHostsByCompany(companyId: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("companyId", companyId);
    // this.analytics.logEvent(AnalyticsConstants.getHostsByCompanyEvent);
    return this.http.get(HOST_API + 'getallhosts', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    })
      .pipe(
        catchError(this.handleError.bind(this)),
        tap(hosts => {
          //@ts-ignore
          this.hostService.setHosts(hosts);
        })
      )
  }

  getHostsByVenue(venueId: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("venueId", venueId);
    // this.analytics.logEvent(AnalyticsConstants.getHostsByVenueEvent);
    return this.http.get(HOST_API + 'getallhosts', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    })
      .pipe(
        catchError(this.handleError.bind(this)),
        tap(hosts => {
          //@ts-ignore
          this.hostService.setHosts(hosts);
        })
      )
  }

  updateeHost(host: HostModelRequest): Observable<HostModelRequest> {
    // this.analytics.logEvent(AnalyticsConstants.updateeHostEvent);
    return this.http
      .post<HostModelRequest>(HOST_API + 'updatehost', host, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  deactiveHost(hostId: string | undefined): Observable<any> {
    let req: DeactivateHostModelRequest = new DeactivateHostModelRequest();
    req.hostId = hostId;
    // this.analytics.logEvent(AnalyticsConstants.deactiveHostEvent);
    return this.http
      .post<any>(HOST_API + 'deactivatehost', req, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  getTermsAndConditions(LanguageId: number, CountryCode: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("LanguageId", LanguageId);
    queryParams = queryParams.append("CountryCode", CountryCode);
    // this.analytics.logEvent(AnalyticsConstants.getVenueDetailsEvent);
    return this.http.get(AUTH_API + 'gettermsandconditions', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    }).pipe(
      tap((response: any) => { }),
      catchError(this.handleError.bind(this))
    )
      ;
  }

  getPrivacyPolicy(LanguageId: number, CountryCode: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("LanguageId", LanguageId);
    queryParams = queryParams.append("CountryCode", CountryCode);
    // this.analytics.logEvent(AnalyticsConstants.getVenueDetailsEvent);
    return this.http.get(AUTH_API + 'getprivacypolicy', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    }).pipe(
      tap((response: any) => { }),
      catchError(this.handleError.bind(this))
    )
      ;
  }

  //PAYMENT
  startusingtrialperiod(): Observable<any> {
    return this.http
    .post<any>(PAYMENT_API + 'startusingtrialperiod', httpOptions)
    .pipe(
      catchError(this.handleError.bind(this))
    )
  }

  makepayment(paymentCredentials: StripePaymentModel): Observable<any>{
    return this.http
    .post<any>(PAYMENT_API + 'makepayment',paymentCredentials, httpOptions)
    .pipe(
      catchError(this.handleError.bind(this))
    )
  }

  getsessionforsubscription(paymentCredentials: StripeCheckoutModel):Observable<any>{
    return this.http
    .post<any>(PAYMENT_API + 'getsessionforsubscription', paymentCredentials, httpOptions)
    .pipe(
      catchError(this.handleError.bind(this))
    )
  }

  generateHash(amount: number):Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("amount", amount);
    return this.http.post<any>(Test_PAYMENT_API+'GenerateHash?'+queryParams,{
      headers: httpOptions,
      params: queryParams})
    .pipe(
      catchError(this.handleError.bind(this))
    )
  }
  generateHashForProduction(amount: number):Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("amount", amount);
    return this.http.post<any>(Test_PAYMENT_API+'GenerateProdHash?'+queryParams,{
      headers: httpOptions,
      params: queryParams})
    .pipe(
      catchError(this.handleError.bind(this))
    )
  }

  unsubscribecompany():Observable<any> {
    return this.http
    .post<any>(PAYMENT_API + 'unsubscribecompany', httpOptions)
    .pipe(
      catchError(this.handleError.bind(this))
    )
  }

  getpaymentsforcompany(pagingModel: PagingModel): Observable<any>{
    return this.http.post<any>(PAYMENT_API+'getpaymentsforcompany',pagingModel,httpOptions)
    .pipe(
      catchError(this.handleError.bind(this))
    )
  }

  //ADMIN PANEL
  getAdminUserProfile(): Observable<any> {
    // this.analytics.logEvent(AnalyticsConstants.getUserProfileEvent);
    return this.http
      .get(ADM_API + 'getuserprofile', httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  signOutAdmin(isRemembered: any): Observable<any> {
    return this.http
      .post<any>(BUSSN_API + `signout?isRemembered=${isRemembered}`, httpOptions)
      .pipe(
        tap(response => { }),
        catchError(this.handleError.bind(this))
      )
  }

  getWeeklyReservationsForVenue(model: WeeklyReservationsRequestDTO): Observable<any> {
    return this.http.post<any>(REPORT_API + 'getweeklyreservations', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  downloadWeeklyReservationsForVenue(model: WeeklyReservationsRequestDTO): Observable<any> {
    return this.http.post(REPORT_API + 'downloadweeklyreservationsreport', model, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: "blob"
    })
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  sendToMailWeeklyReservationsForVenue(model: WeeklyReservationsRequestDTO): Observable<any> {
    return this.http.post(REPORT_API + 'sentweeklyreservationsreporttomail', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  getTotalReservationsForVenue(model: TotalReservationsForVenueRequestDTO): Observable<any> {
    return this.http.post<any>(REPORT_API + 'gettotalreservations', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  downloadTotalReservationsForVenue(model: TotalReservationsForVenueRequestDTO): Observable<any> {
    return this.http.post(REPORT_API + 'downloadtotalreservationsreport', model, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: "blob"
    })
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  sendToMailTotalReservationsForVenue(model: TotalReservationsForVenueRequestDTO): Observable<any> {
    return this.http.post(REPORT_API + 'senttotalreservationsreporttomail', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  getMostVisitedEvents(model: MostVisitedEventsRequestDTO): Observable<any> {
    return this.http.post<any>(REPORT_API + 'getmostvisitedeventsreservations', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  downloadMostVisitedEventsForVenue(model: MostVisitedEventsRequestDTO): Observable<any> {
    return this.http.post(REPORT_API + 'downloadmostvisitedeventsreservationsreport', model, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: "blob"
    })
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  sendToMailMostVisitedEventsForVenue(model: MostVisitedEventsRequestDTO): Observable<any> {
    return this.http.post(REPORT_API + 'sentmostvisitedeventsreservationsreport', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }


  getUpcomingEventReservationStatistics(model: UpcomingEventReservationsModelDTO): Observable<any> {
    return this.http.post<any>(REPORT_API + 'getupcomingeventreservations', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  downloadUpcomingEventReservationStatistics(model: UpcomingEventReservationsModelDTO): Observable<any> {
    return this.http.post(REPORT_API + 'downloadupcomingeventreservationsreport', model, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: "blob"
    })
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  sendToMailUpcomingEventReservationStatistics(model: UpcomingEventReservationsModelDTO): Observable<any> {
    return this.http.post(REPORT_API + 'sentupcomingeventreservationsreporttomail', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  getPastReservationsDetails(model: ReservationsDetailsForEventModelDTO): Observable<any> {
    return this.http.post<any>(REPORT_API + 'getpastreservationsforreportbyeventid', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  getPastEventsForVenue(venueId: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.appendAll({
      venueId: venueId,
    });
    return this.http.get(REPORT_API + 'getfinishedeventsforcombo', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    })
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  downloadPastEventsReservations(model: PastOrUpcomingEventReservationsRequestDTO): Observable<any> {
    return this.http.post(REPORT_API + 'downloadpastreservationsforreportbyeventid', model, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: "blob"
    })
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  sendToMailPastEventsReservations(model: PastOrUpcomingEventReservationsRequestDTO): Observable<any> {
    return this.http.post(REPORT_API + 'sentpastreservationsforreportbyeventidtomail', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  getUpcomingReservationsDetails(model: ReservationsDetailsForEventModelDTO): Observable<any> {
    return this.http.post<any>(REPORT_API + 'getupcomingreservationsforreportbyeventid', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  getUpcomingEventsForVenue(venueId: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.appendAll({
      venueId: venueId,
    });
    return this.http.get(REPORT_API + 'getupcomingeventsforcombo', {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: queryParams
    })
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  downloadUpcomingEventsReservations(model: PastOrUpcomingEventReservationsRequestDTO): Observable<any> {
    return this.http.post(REPORT_API + 'downloadupcomingreservationsforreportbyeventid', model, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: "blob"
    })
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  sendToMailUpcomingEventsReservations(model: PastOrUpcomingEventReservationsRequestDTO): Observable<any> {
    return this.http.post(REPORT_API + 'sentupcomingreservationsforreportbyeventidtomail', model, httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }


}
